import MutualFundGuard from "./MutualFundGuard";
import { lazy } from "react";
import { R_MfRoutes } from "../../utils/Routes";
import SuspenseWrapper from "../../components/CustomLazyLoading/CustomLazyLoading";

const FolioDetails = lazy(
  () => import("./RevampedMFDetailsPage/MfDetailsPage"),
);
const CapitalGainStatement = lazy(
  () => import("./CapitalGainStatement/CapitalGainStatement"),
);
const AccountStatement = lazy(
  () => import("./AccountStatement/AccountStatement"),
);
const ExitLoadStatement = lazy(
  () => import("./ExitLoadStatement/ExitLoadStatement"),
);
const MfTransact = lazy(
  () =>
    import("./RevampedMFDetailsPage/components/MfMyServices/MfTransact/MfTransact"),
);
const MfMyStatements = lazy(
  () =>
    import("./RevampedMFDetailsPage/components/MfMyServices/MfMyStatements/MfMyStatements"),
);
const SchemaFundDetails = lazy(
  () =>
    import("./RevampedMFDetailsPage/components/SchemaFundDetailsScreen/SchemaFundDetails"),
);
const MutualFundRoutesFn = () => {
  return [
    {
      path: R_MfRoutes.mutualFund_BaseUrl,
      element: <MutualFundGuard />,
      children: [
        {
          path: R_MfRoutes.mutualFund_Details,
          element: <SuspenseWrapper LazyLoadingComponent={FolioDetails} />,
        },
        {
          path: R_MfRoutes.mutualFund_Transact,
          element: <SuspenseWrapper LazyLoadingComponent={MfTransact} />,
        },
        {
          path: R_MfRoutes.mutualFund_MyStatements,
          element: <SuspenseWrapper LazyLoadingComponent={MfMyStatements} />,
        },
        {
          path: R_MfRoutes.mutualFund_SchemaFundDetails,
          element: <SuspenseWrapper LazyLoadingComponent={SchemaFundDetails} />,
        },
        {
          path: R_MfRoutes.mutualFund_CapitalGains,
          element: (
            <SuspenseWrapper LazyLoadingComponent={CapitalGainStatement} />
          ),
        },
        {
          path: R_MfRoutes.mutualFund_AccountStatement,
          element: <SuspenseWrapper LazyLoadingComponent={AccountStatement} />,
        },
        {
          path: R_MfRoutes.mutualFund_ExitLoad,
          element: <SuspenseWrapper LazyLoadingComponent={ExitLoadStatement} />,
        },
      ],
    },
  ];
};
export { MutualFundRoutesFn };
